import { APP_BASE_HREF } from '@angular/common';
import { Component, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { UiModule } from '@shared/ui';

import { RedirectToPhpGuard } from '../app/redirect-to-php-guard.service';

import { CompatModalsComponent } from './compat-modals.component';

@Component({
  template: `<!-- this is empty -->`,
})
export class EmptyComponent {}

@NgModule({
  imports: [
    UiModule,
    RouterModule.forRoot([
      {
        path: '**',
        component: EmptyComponent,
        canActivate: [RedirectToPhpGuard],
      },
    ]),
  ],
  declarations: [EmptyComponent, CompatModalsComponent],
  providers: [RedirectToPhpGuard, { provide: APP_BASE_HREF, useValue: '/' }],
  entryComponents: [CompatModalsComponent],
})
export class CompatModalsModule {}



// WEBPACK FOOTER //
// ./src/compat/compat-modals.module.ts